import * as React from 'react';
import styled from 'styled-components';
import BoxHeader from '../../atoms/BoxHeader';

const Schedule = styled.div`
  width: 956px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-box;
  display: -webkit-flexbox;
  display: -moz-flexbox;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  -webkit-box-lines: multiple;
  -moz-box-lines: multiple;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  & .item {
    width: 475px;
    border: 1px solid #c8c8c8;
    background-color: #fff;
  }
  & .title {
    background: #005daa -webkit-gradient(linear, left top, left bottom, color-stop(0.88, #004379), color-stop(0, #075ca1));
    background: #005daa -webkit-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -moz-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -o-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa -ms-linear-gradient(top, #075ca1 0%, #004379 88%);
    background: #005daa linear-gradient(to bottom, #075ca1 0%, #004379 88%);
    line-height: 0;
  }
`;

const InfoHeader = styled.span`
  border-bottom: solid 1px;
`;
const BoxHeigh = styled.div`
  padding: 6px 20px;
`;
const Meeting = styled.div`
  padding-bottom: 20px;
  & .title {
    margin-bottom: 10px;
  }
  & .boxheigh {
    padding: 6px 20px;
  }
  & h4 {
    font-size: 150%;
  }
  & th,
  td {
    padding-top: 5px;
    vertical-align: top;
    font-weight: bold;
  }
  & th {
    width: 45px;
  }
  & td {
    padding-left: 1em;
    text-indent: -1em;
  }
`;

const MeetingList = styled.div`
  margin-left: 6px;
  padding-bottom: 5px;
  & .title {
    margin-bottom: 5px;
    width: 475px;
    height: 36px;
    position: relative;
  }
  & h3 {
    width: 132px;
    height: 36px;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
const Logbox = styled.div `
padding: 0.5em 0.5em 1em 0.5em;
& ul {
    margin: 4px 4px 4px 20px;
    list-style: disc;
  }
`;

const Hope = styled.div `
width: 956px !important;
border: 1px solid #c8c8c8;
background-color: #fff;
padding-bottom: 10px;
margin-top: 6px;
  & .title {
    height: 36px;
    margin-bottom: 10px;
    position: relative;
  }
  & h3 {
    width: 132px;
    height: 36px;
    position: absolute;
    top: 0;
    left: 0;
  }
  & .title .bana {
    position: absolute;
    right: 5px;
    top: 50%;
    /* margin-top:-10px; */
  }
  & .inner {
    width: 930px;
    margin: 0 auto;
  }
  & .text {
    width: 490px;
    float: left;
  }
  & table {
    width: 490px;
    margin-top: 8px;
    border-collapse: separate;
    border-spacing: 2px;
  }
  & th, td {
    padding: 5px 3px;
  }
  & th {
    width: 120px;
    background-color: #d8e3f8;
    text-align: center;
    color: #002442;
    font-weight: bold;
  }
  & td {
    background-color: #f0f0f0;
  }
  & td p {
    margin-top: 5px;
  }
  & td a {
    background-color: #005daa;
    padding: 2px 3px;
    font-size: 80%;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
  }
  & td a:hover {
    text-decoration: underline;
  }
  & td strong {
    font-size: 110%;
  }
  
`
const Map = styled.div `
width: 435px;
float: right;
background-color: #f0f0f0;
text-align: center;
padding: 5px 0;
`
const HomeMainRight = () => {
  return (
    <div className="main-right">
      <Schedule>
        {/* 次回例会 */}
        <Meeting className="item">
          <BoxHeader title="次回例会案内" subTitle="Make up information" linkHeader= {false}></BoxHeader>
          <BoxHeigh className="boxheigh">
            <h4>
              <InfoHeader>例会の実施についてご案内</InfoHeader>
            </h4>
            <br></br>
            例会の再開日につきまして、当初は6月からを予定しておりましたが、現在の社会情勢を鑑みて、緊急持ち回り理事会を実施したうえで、下記の例会を休会と決定いたしました。
            <br></br>
            <br></br>
            <ul>
              <li>2021年6月 3日（木）</li>
            </ul>
            <ul>
              <li>2021年6月10日（木）</li>
            </ul>
            <br></br>
            例会の再開は、6月24日（木）年度末夜間例会を予定しておりますが、改めてご連絡をさせていただきます。
            <br></br>
          </BoxHeigh>
        </Meeting>
        {/* 次回例会 EN */}

        <MeetingList className="item">
          <BoxHeader link='/schedule' linkTitle="スケジュール一覧" title="例会スケジュール" subTitle="Schedule" linkHeader= {true}></BoxHeader>
          <BoxHeigh className="boxheigh">
          <table>
                <tbody>
                {/* ピー開始 */}
                  <Logbox className="text">
                    <ul>
                      <li>2021年 6月 3日（木）<s>12:30-13:30 通常例会</s> → 休会</li>
                      <li>2021年 6月10日（木）<s>12:30-13:30 通常例会</s> → 休会</li>
                      <li>2021年 6月17日（木） 国際大会の為、振替休会</li>
                    </ul>
                    <br></br>
                    <br></br>
                    何卒、ご了承くださいますようお願い申し上げます。
                  </Logbox>
                  {/* コピー終 */}
                </tbody>
              </table>
          </BoxHeigh>
        </MeetingList>
        {/* 例会ご希望の方 */}
        <Hope className="item">
        <BoxHeader link='/translate' linkTitle="English" title="例会ご希望の方へ" subTitle="Meeting" linkHeader= {true}></BoxHeader>
        <div className="inner clearfix">
        {/* 右 */}
            <div className="text">
              <br />
              <table>
                <tbody>
                  <tr>
                    <th scope="row">例会日・時間</th>
                    <td><strong>毎週　木曜日　　１２：３０～１３：３０</strong></td>
                  </tr>
                  <tr>
                    <th scope="row">会 場</th>
                    <td>
                      <strong>帝国ホテル</strong> <a href="http://www.imperialhotel.co.jp/j/" target="_blank">URL</a><br/>
                      <span className="sfont">〒100-8558 東京都千代田区内幸町1-1-1<br/>
                        TEL：03-3504-1111（代）</span>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">登録料</th>
                    <td> [国内のお客さま]<br/>
                      通　常：5,000円　　　　軽食週：4,000円
                      <p>[海外からのお客さま・東京中央新RC]<br/>
                        全　週：3,000円 </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <span className="sfont">※例会日は変更になる場合がありますので、予定表をご確認の上お出かけください。</span>
            </div>
            {/* 右 END */}
            {/* 地図 */}
            <Map>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6482.433057966167!2d139.75594183001914!3d35.67167005780774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc637562b5aac0ea6!2z5bid5Zu944Ob44OG44Or5p2x5Lqs!5e0!3m2!1sja!2sjp!4v1476000121707"
                width="425" height="243" frameBorder="0"  allowFullScreen></iframe>
            </Map>
            {/* 地図 END */}
          </div>
        </Hope>
        {/* 例会ご希望の方へ END */}
      </Schedule>
    </div>
  );
};
export default HomeMainRight;
